import {useQuery} from "@tanstack/react-query";
import {useContext, useEffect, useState} from "react";

import type {Listing} from "../../../models/listing";
import {sanitizeListings} from "../../../models/listing";
import {updateListWS} from "../../../utils";
import WebSocketContext from "../../contexts/WebSocketContext";
import {useListingService} from "../useListingService";

type Params = {
    isDemo?: boolean;
};

export const useWatchListings = ({isDemo}: Params = {}) => {
    const ws = useContext(WebSocketContext);
    const listingService = useListingService();
    const [listings, setListings] = useState<Listing[] | undefined>();

    const {data, refetch, isLoading} = useQuery({
        queryKey: ["/listings/all", isDemo],
        queryFn: async () => {
            return listingService.fetchAllListings(isDemo);
        }
    });

    useEffect(() => {
        setListings(data);
    }, [data]);

    useEffect(() => {
        function syncListings(payload: WSPayload<Listing>) {
            setListings(prev => {
                const listings = updateListWS(prev ?? [], payload);
                return sanitizeListings(listings);
            });
        }

        ws?.on<WSRoom>("listing", syncListings);
        return () => {
            ws?.off("listing", syncListings);
        };
    }, [ws, refetch]);

    return {
        isLoading,
        listings,
        refetch
    };
};
